import { render } from "./UsageDetails.vue?vue&type=template&id=6f16b1e2"
import script from "./UsageDetails.vue?vue&type=script&lang=js"
export * from "./UsageDetails.vue?vue&type=script&lang=js"

import "./UsageDetails.vue?vue&type=style&index=0&id=6f16b1e2&lang=scss"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__